
import { defineComponent, PropType } from 'vue'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'
import { ResponseKyuyohiSettingDetail } from '@/repositories/fuzoku-meisai/junsoku/data'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'

export default defineComponent({
  components: {
    SettingPanel
  },
  props: {
    idPrefix: {
      type: String,
      required: true
    },
    settings: {
      type: Object as PropType<ResponseKyuyohiSettingDetail>
    }
  },
  emits: {
    updateTab: (idPrefix: string, detail: ResponseKyuyohiSettingDetail) => true
  },
  setup (props, { emit }) {
    const onUpdatedSetting = (panelName: string, item: ResponseSettingItem) => {
      const settings = props.settings
      if (!settings) {
        throw new Error('require settings.')
      }
      switch (panelName) {
        case 'doctor':
          settings.doctor = item
          break
        case 'nurse':
          settings.nurse = item
          break
        case 'therapist':
          settings.therapist = item
          break
        case 'technician':
          settings.technician = item
          break
        case 'clerk':
          settings.clerk = item
          break
        case 'skilled-laborer':
          settings.skilledLaborer = item
          break
        case 'other':
          settings.other = item
          break
        default:
          throw new Error(`unknown panelName: ${panelName}`)
      }
      emit('updateTab', props.idPrefix, settings)
    }

    return {
      onUpdatedSetting
    }
  }
})
